// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"acef9c97","411":"740d46bd","496":"c2658189","799":"1a7f5b74","954":"9569d43a","980":"473937d5"}[chunkId] + ".chunk.css";
};